'use strict';

var configService = require('vimmi-web-utils/cjs/configService');
var makeHash = require('vimmi-web-utils/cjs/makeHash');
var getCurrentProtocol = require('vimmi-web-utils/cjs/getCurrentProtocol');
var getPathFileExt = require('vimmi-web-utils/cjs/getPathFileExt');
var device = require('vimmi-web-utils/cjs/device');
var appError = require('vimmi-web-utils/cjs/errors/appError');
var errorCodes = require('vimmi-web-utils/cjs/errors/errorCodes');
var doFetch = require('vimmi-web-utils/cjs/doFetch');
var formatPath = require('vimmi-web-utils/cjs/ams/formatPath');
var getUrlCacheIndex = require('vimmi-web-utils/cjs/getUrlCacheIndex');
var localCache = require('vimmi-web-utils/cjs/localCache');
var generateHeaders = require('vimmi-web-utils/cjs/ams/generateHeaders');
var fetchAMS = require('vimmi-web-utils/cjs/ams/fetchAMS');
var normDomain = require('vimmi-web-utils/cjs/normDomain');
var eventEmitter = require('vimmi-web-utils/cjs/eventEmitter');
var isValidUrl = require('vimmi-web-utils/cjs/isValidUrl');

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.
Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.
THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

// class ConfigService extends ConfigBase {
//     constructor() {
//         super();
//     }
//
//     set(key: {}, value?: any): boolean
//     set(key: string, value: any = null): boolean {
//         if (typeof key === 'object') {
//             for (let subKey in key as {}) {
//                 // @ts-ignore
//                 super.set(subKey, key[subKey]);
//             }
//             return true;
//         } else {
//             return super.set(key as string, value);
//         }
//     }
//
// }
var Config = new configService.ConfigService();

function isBrowserSupportedEME() {
    return !!window.MediaKeys &&
        !!window.navigator &&
        !!window.navigator.requestMediaKeySystemAccess &&
        typeof window.navigator.requestMediaKeySystemAccess === 'function' &&
        !!window.MediaKeySystemAccess &&
        // eslint-disable-next-line no-restricted-syntax
        !!window.MediaKeySystemAccess.prototype.getConfiguration;
}
function isKeySystemSupported(keySystem, config) {
    return new Promise(function (resolve, reject) {
        if (window.navigator.requestMediaKeySystemAccess) {
            window.navigator.requestMediaKeySystemAccess(keySystem, config).then(function (keySystemAccess) {
                resolve(keySystem);
            })["catch"](function () {
                reject(keySystem);
            });
        }
        else {
            reject(keySystem);
        }
    });
}
function DRMSupportsStatus() {
    return __awaiter(this, void 0, void 0, function () {
        var keySystems, response, config, testVideoElement, promise;
        return __generator(this, function (_a) {
            keySystems = Config.get('drmKeySystems');
            response = {
                defaultEME: false,
                MSEME: false,
                WebKitEME: false,
                hasEME: false,
                supportedSystems: {},
                unsupportedSystems: {}
            };
            config = [{
                    'initDataTypes': ['cenc'],
                    'videoCapabilities': [
                        { contentType: 'video/mp4; codecs="avc1.42E01E"' },
                        { contentType: 'video/webm; codecs="vp8"' }
                    ]
                }];
            testVideoElement = document.createElement('video');
            promise = new Promise(function (resolve, reject) {
                if (!testVideoElement.mediaKeys) {
                    var promises = [];
                    if (isBrowserSupportedEME()) {
                        response.defaultEME = true;
                        response.hasEME = true;
                        var _loop_1 = function (keySys) {
                            if (keySystems.hasOwnProperty(keySys)) {
                                var t_1 = Array.isArray(keySystems[keySys]) ? keySystems[keySys] : [keySystems[keySys]];
                                var _loop_2 = function (dummy) {
                                    promises.push(isKeySystemSupported(t_1[dummy], config).then(function (keySystem) {
                                        response.supportedSystems[keySys] = response.supportedSystems[keySys] || [];
                                        response.supportedSystems[keySys].push(t_1[dummy]);
                                        return keySystem;
                                    })["catch"](function (keySystem) {
                                        response.unsupportedSystems[keySys] = response.unsupportedSystems[keySys] || [];
                                        response.unsupportedSystems[keySys].push(t_1[dummy]);
                                        return keySystem;
                                    }));
                                };
                                for (var dummy in t_1) {
                                    _loop_2(dummy);
                                }
                            }
                        };
                        for (var keySys in keySystems) {
                            _loop_1(keySys);
                        }
                    }
                    else if (window.MSMediaKeys && typeof window.MSMediaKeys === 'function') {
                        response.MSEME = true;
                        response.hasEME = true;
                        for (var keySys in keySystems) {
                            if (keySystems.hasOwnProperty(keySys)) {
                                var t = Array.isArray(keySystems[keySys]) ? keySystems[keySys] : [keySystems[keySys]];
                                for (var dummy in t) {
                                    if (MSMediaKeys.isTypeSupported(t[dummy])) {
                                        response.supportedSystems[keySys] = response.supportedSystems[keySys] || [];
                                        response.supportedSystems[keySys].push(t[dummy]);
                                    }
                                    else {
                                        response.unsupportedSystems[keySys] = response.unsupportedSystems[keySys] || [];
                                        response.unsupportedSystems[keySys].push(t[dummy]);
                                    }
                                }
                            }
                        }
                        // @ts-ignore
                    }
                    else if (testVideoElement.webkitGenerateKeyRequest && typeof testVideoElement.webkitGenerateKeyRequest === 'function') {
                        response.WebKitEME = true;
                        response.hasEME = true;
                        for (var keySys in keySystems) {
                            if (keySystems.hasOwnProperty(keySys)) {
                                var t = Array.isArray(keySystems[keySys]) ? keySystems[keySys] : [keySystems[keySys]];
                                for (var dummy in t) {
                                    // @ts-ignore
                                    if (testVideoElement.canPlayType('video/mp4', t[dummy])) {
                                        response.supportedSystems[keySys] = response.supportedSystems[keySys] || [];
                                        response.supportedSystems[keySys].push(t[dummy]);
                                    }
                                    else {
                                        response.unsupportedSystems[keySys] = response.unsupportedSystems[keySys] || [];
                                        response.unsupportedSystems[keySys].push(t[dummy]);
                                    }
                                }
                            }
                        }
                    }
                    else {
                        resolve(response);
                    }
                    if (promises.length) {
                        Promise.all(promises).then(function () {
                            resolve(response);
                        });
                    }
                }
                else {
                    response.hasEME = true;
                    resolve(response);
                }
            });
            return [2 /*return*/, promise.then(function (response) {
                    if (device.device.isSafari() && isBrowserSupportedEME() && !response.supportedSystems['HLS/FAIRPLAY']) {
                        response.supportedSystems['HLS/FAIRPLAY'] = ['com.apple.fps.1_0'];
                    }
                    return response;
                })];
        });
    });
}
function hasContentSupportsDRM(contentDrmTypes, browserSupportsDrmTypes) {
    /** priority for DASH/PLAYREADY in Edge browser*/
    if (device.device.isEdge()) {
        var dType = 'DASH/PLAYREADY';
        if (contentDrmTypes.indexOf(dType) !== -1 && browserSupportsDrmTypes.indexOf(dType) !== -1) {
            console.log("used " + dType + " by default for Edge browser");
            return dType.toUpperCase();
        }
    }
    /** priority for DASH/WIDEVINE*/
    // let dType = 'DASH/WIDEVINE';
    // if (contentDrmTypes.indexOf(dType) !== -1 && browserSupportsDrmTypes.indexOf(dType) !== -1) {
    //     return dType.toUpperCase()
    // }
    for (var i = 0; i !== contentDrmTypes.length; i++) {
        if (browserSupportsDrmTypes.indexOf(contentDrmTypes[i].toUpperCase()) !== -1) {
            return contentDrmTypes[i].toUpperCase();
        }
    }
    return null;
}
//
// export function getCurrentKeySystem(options) {
//     let EMEStats = Config.get('EMEStats');
//     let isAutoDetect = !options.hasOwnProperty('drm_types') || options.drm_types === undefined;
//
//     /** if browser support EME but didn't detect supports of keySystems*/
//     let supportedSystems = EMEStats.supportedSystems;
//     if (this.isBrowserSupportedEME() && !supportedSystems.length) {
//         if (Device.isSafari() && Device.isAppleDevice()) {
//             supportedSystems = ['HLS/FAIRPLAY'];
//         } else {
//             supportedSystems = ['DASH/WIDEVINE'];
//         }
//     }
//
//     let allowedSystems = isAutoDetect ? Object.keys(Config.get('keySystems')) : options.drm_types || [];
//     let keySystemToUse = null;
//
//     if (options.drmType) {
//         /** try to detect is the keySystems supports */
//         keySystemToUse = supportedSystems.find((keySystem) => {
//             return options.drmType.toLowerCase() === keySystem.toLowerCase();
//         });
//         this.logger.log('#getCurrentKeySystem force used the keySystem:', options.drmType, {
//             allowedSystems: allowedSystems,
//             isAutoDetect: isAutoDetect,
//             trueSupportedSystems: EMEStats.supportedSystems,
//             fakeSupportedSystems: supportedSystems,
//         });
//     } else {
//         /** assumed that license url and certificate defined in options*/
//         let allowedAsString = allowedSystems.join(',').toLowerCase();
//         keySystemToUse = supportedSystems.find((keySystem) => {
//             return allowedAsString.indexOf(keySystem.toLowerCase()) !== -1
//         });
//         this.logger.log('#getCurrentKeySystem detect keySystem', {
//             allowedSystems: allowedSystems,
//             trueSupportedSystems: EMEStats.supportedSystems,
//             fakeSupportedSystems: supportedSystems,
//             calculatedSystem: keySystemToUse
//         });
//     }
//
//     return keySystemToUse;
// }

function getAccessData() {
    return {
        sid: Config.get('authInfo.sid'),
        privateId: Config.get('authInfo.privateId'),
        device_id: Config.get('authInfo.device_id'),
        public_app_key: Config.get('authInfo.public_app_key'),
        device_key: Config.get('authInfo.device_key'),
        "Api-Version": Config.get('appInfo.Api-Version'),
        version: Config.get('appInfo.version'),
        language: Config.get('appInfo.language'),
        customer: Config.get('customer'),
        platform: Config.get('platform'),
        backend: Config.get('backend'),
        deviceRestrictions: Config.get('deviceRestrictions')
    };
}
function fillAssetFromResponse(asset, item) {
    if (item === void 0) { item = {}; }
    asset.item = item;
    asset.media_id = item.id;
    asset.media_session_id = makeHash.makeHash(32);
    if (item.itype) {
        asset.itype = item.itype;
    }
    if (item.origin && !asset.origin) {
        asset.origin = item.origin;
    }
    if (item.media_supplier) {
        asset.media_supplier = item.media_supplier;
    }
    if (item.mid) {
        asset.alphaId = item.mid;
    }
    return asset;
}
// export function prepareAMSHeaders(itemAMSHeader: { [key: string]: any } = {}) {
//
//     let headers: any = {
//         // "PrivateId": Config.get('authInfo.privateId'),
//         // "sid": Config.get('authInfo.sid'),
//         // "udid": Config.get('authInfo.device_id'),
//         // "api_key": getApiKey(time),
//         // "Api-Version": Config.get('appInfo.Api-Version'),
//         // "Device-Info": Config.get('appInfo.Device-Info'),
//         // "time": time,
//     };
//     if (Config.get('authInfo.privateId')) {
//         headers.PrivateId = Config.get('authInfo.privateId')
//     }
//     if (Config.get('authInfo.sid')) {
//         headers.sid = Config.get('authInfo.sid')
//     }
//     if (Config.get('authInfo.device_id')) {
//         headers.udid = Config.get('authInfo.device_id')
//     }
//     if (Config.get('appInfo.Device-Info')) {
//         headers["Device-Info"] = Config.get('appInfo.Device-Info')
//     }
//
//     if (Config.get('authInfo.privateId') && Config.get('authInfo.sid') && Config.get('authInfo.device_id') && Config.get('authInfo.public_app_key')) {
//         if (Config.get('appInfo.Api-Version')) {
//             headers["Api-Version"] = Config.get('appInfo.Api-Version')
//         }
//         let time = parseInt(String(Date.now() / 1000));
//         headers["api_key"] = getApiKey(time);
//         headers["time"] = time;
//     }
//
//
//     return Object.assign(headers, itemAMSHeader);
// }
function getMetadataLinkFromTemplate(asset, isLive) {
    if (isLive === void 0) { isLive = false; }
    var template = Config.get('playTemplates.info.' + (isLive ? 'live' : 'vod'));
    if (template) {
        return template.replace(/\{MID\}/gi, asset.alphaId);
    }
    return null;
}
function formatMetadataUrl(url, assetCDNQuery) {
    if (assetCDNQuery === void 0) { assetCDNQuery = {}; }
    var req = /(\{\{[a-z]+\}\})/gi;
    for (var key in assetCDNQuery) {
        if (key === 'domain' &&
            /(https*\:\/\/[a-z\._-]+)/im.test(getCurrentProtocol.getCurrentProtocol() + '//' + assetCDNQuery[key])) {
            url.hostname = assetCDNQuery[key];
        }
        else if (req.test(assetCDNQuery[key])) {
            url.searchParams.set(key, assetCDNQuery[key].replace(req, url.searchParams.get(key) || 'vimmi'));
        }
        else {
            url.searchParams.set(key, assetCDNQuery[key]);
        }
    }
    return url;
}
//
// export function fromBase64(data: any): any {
//     const wordArray = CryptoJS.enc.Base64.parse(data);
//     return CryptoJS.enc.Utf8.stringify(wordArray);
// }
//
// export function toBase64(data: any): string {
//     if (data instanceof Object || data instanceof Array) {
//         // return window.btoa(JSON.stringify(data));
//         const wordArray = CryptoJS.enc.Utf8.parse(JSON.stringify(data)); // WordArray object
//         return CryptoJS.enc.Base64.stringify(wordArray);
//     }
//     return window.btoa(data);
// }
function rewriteMetadataXMLtoJSON(metadataUrl) {
    return metadataUrl.replace(/(\/metadata\.xml)/i, '/metadata.json');
}
// export function formatAMSLink(path: string, backendUrl: string, deviceRestrictions: Array<string> = []): URL {
//     let url: URL = new URL(`${protocol}//${backendUrl}${path}`);
//     if (deviceRestrictions && deviceRestrictions.length) {
//         url.searchParams.set('d', deviceRestrictions.join(','));
//     }
//     return url
// }
//
// export function getProtocol() {
//     return location.protocol.indexOf('http') === -1 ? 'https:' : location.protocol;
// // }
//
// export function normalizeDomain(url: string) {
//     url = url.replace('http://', '').replace('https://', '');
//     if (url.lastIndexOf('/') === url.length - 1) {
//         url = url.slice(0, length - 1)
//     }
//     return url;
// }
// export function formatAMSLink(path: string): URL {
//     path = path.indexOf('/') === 0 ? path.slice(1) : path;
//     path = path.lastIndexOf('/') === path.length - 1 ? path.slice(0, path.length - 1) : path;
//
//     let url: URL = new URL(`${getProtocol()}//${normalizeDomain(Config.get('backend'))}/${path}/`);
//     let deviceRestrictions = Config.get('deviceRestrictions')
//     if (deviceRestrictions && deviceRestrictions.length) {
//         url.searchParams.set('d', deviceRestrictions.join(','));
//     }
//     return url
// }
//getPathFIleExt
// export function getExtension(uri: string) {
//     const uriObj = new URL(uri);
//     const uriPieces = uriObj.pathname.split('/');
//     const uriFilename = uriPieces.pop();
//     const filenamePieces = uriFilename.split('.');
//
//     // Only one piece means there is no extension.
//     if (filenamePieces.length == 1) {
//         return '';
//     }
//
//     return filenamePieces.pop().toLowerCase();
// }
function getMimeType(playbackUrlItem, mimeTypes) {
    var uri = playbackUrlItem.url || '';
    var extension = getPathFileExt.getPathFileExt(uri);
    return extension ? mimeTypes[extension] || null : null;
}
// export function getApiKey(time: number) {
//     let apiKeyParams = [
//         Config.get('authInfo.privateId'),
//         Config.get('authInfo.sid'),
//         Config.get('authInfo.device_id'),
//         Config.get('authInfo.public_app_key'),
//         time
//     ];
//     return md5(apiKeyParams.join(''));
// }
function getDTypeForAsset(asset) {
    var dType = null;
    switch ((asset.origin || '').toLowerCase()) {
        case 'vulpes': //live - works by old way (with refreshing the methadata)
            dType = 'GCAST';
            break;
    }
    return dType;
}
// export function makeHash(length: number) {
//     let result = '';
//     let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
//     let charactersLength = characters.length;
//     for (let i = 0; i < length; i++) {
//         result += characters.charAt(Math.floor(Math.random() * charactersLength));
//     }
//     return result.toLowerCase();
// }
function getRecursive(value, name) {
    return value && (value[name] !== null && value[name] !== undefined)
        ? value[name]
        : null;
}
function setRecursive(data, name, isLast) {
    if (isLast) {
        //      data[name] = value;
        return data;
    }
    else if (!data[name]) {
        data[name] = {};
    }
    return data[name];
}
function extendAsset(asset) {
    if (asset && !asset.get) {
        asset.get = function (key, defaultVal) {
            if (key === void 0) { key = null; }
            if (defaultVal === void 0) { defaultVal = null; }
            if (!key) {
                return null;
            }
            var chunks = key.split('.');
            if (chunks.length > 1) {
                var lastVal = asset;
                while (chunks.length) {
                    lastVal = getRecursive(lastVal, chunks.shift());
                }
                return lastVal || defaultVal;
            }
            else {
                return asset[key] || defaultVal;
            }
        };
        asset.set = function (key, value) {
            if (value === void 0) { value = null; }
            if (key) {
                var chunks = key.split('.');
                var confData = asset;
                var lastKey = key;
                if (chunks.length > 1) {
                    while (chunks.length) {
                        lastKey = chunks.shift();
                        confData = setRecursive(confData, lastKey, chunks.length === 0);
                    }
                }
                if (value && !Array.isArray(value) && typeof value === 'object' && Object.keys(value).length) {
                    confData[lastKey] = confData[lastKey] || {};
                    for (var subKey in value) {
                        confData[lastKey][subKey] = value[subKey];
                    }
                }
                else {
                    confData[lastKey] = value;
                }
                return true;
            }
        };
    }
}

var MetadataHandler = /** @class */ (function () {
    function MetadataHandler(vimmiPI) {
        this.vimmiPI = vimmiPI;
        this.analyticsModule = null;
        this.beforeMetadataReqCallback = null;
    }
    MetadataHandler.prototype.handle = function (inputOptions) {
        return __awaiter(this, void 0, void 0, function () {
            var asset;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        asset = inputOptions;
                        extendAsset(asset);
                        if (asset.media_id) {
                            asset.item = asset.item || {};
                            asset.item.id = asset.media_id;
                        }
                        asset = fillAssetFromResponse(asset, asset.item || {});
                        if (!asset.playback_url) return [3 /*break*/, 1];
                        asset.media = [
                            {
                                itype: null,
                                link: asset.playback_url //means metadata url
                            }
                        ];
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.vimmiPI.loadPlayTemplates(true)];
                    case 2:
                        _a.sent();
                        asset.media = [
                            {
                                itype: null,
                                link: getMetadataLinkFromTemplate(asset, asset.isLive)
                            }
                        ];
                        asset.playback_url = asset.media[0].link;
                        _a.label = 3;
                    case 3: return [4 /*yield*/, this.handleAsset(asset)];
                    case 4: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MetadataHandler.prototype.attachAnalytics = function (analyticsModule) {
        if (analyticsModule) {
            this.analyticsModule = analyticsModule;
        }
        return this;
    };
    MetadataHandler.prototype.beforeMetadataReq = function (fn) {
        this.beforeMetadataReqCallback = fn;
    };
    MetadataHandler.prototype.isApplicableMetadataLang = function (asset) {
        var item = asset.item;
        if (!item) {
            return false;
        }
        var dType = getDTypeForAsset(asset);
        var mediaSupplier = (item.media_supplier || "").toLowerCase();
        return !!(asset.deliveryMethod === 'metadata' && ((dType || mediaSupplier === 'ais') && (item.m_audio && item.m_audio.length >= 1)));
    };
    MetadataHandler.prototype.isApplicableLang = function (asset, lang) {
        var dType = getDTypeForAsset(asset);
        var mediaSupplier = (asset.item.media_supplier || "").toLowerCase();
        return !!(asset.deliveryMethod === 'metadata' && ((dType || mediaSupplier === 'ais') && (asset.item.m_audio && asset.item.m_audio.indexOf(lang) !== -1)));
    };
    MetadataHandler.prototype.changeLang = function (asset, newAudioLang) {
        return __awaiter(this, void 0, void 0, function () {
            var dType, i, mediaItem, metadataLink, url, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.isApplicableLang(asset, newAudioLang)) return [3 /*break*/, 5];
                        dType = getDTypeForAsset(asset);
                        asset.metadataLang = newAudioLang;
                        i = 0;
                        _b.label = 1;
                    case 1:
                        if (!(i !== asset.media.length)) return [3 /*break*/, 4];
                        mediaItem = asset.media[i];
                        metadataLink = (asset.preview && mediaItem.preview_info && mediaItem.preview_info.link) ? mediaItem.preview_info.link : mediaItem.link;
                        url = formatMetadataUrl(new URL(metadataLink), Object.assign({ l: newAudioLang }, dType ? { d: dType } : {}));
                        if (asset.preview) {
                            mediaItem.preview_info.link = url.toString();
                        }
                        else {
                            mediaItem.link = url.toString();
                        }
                        _a = mediaItem;
                        return [4 /*yield*/, this.getMetadataInfo(asset, mediaItem)];
                    case 2:
                        _a.CDNMetadata = _b.sent();
                        asset.playbackUrls = mediaItem.CDNMetadata.playbackUrls;
                        _b.label = 3;
                    case 3:
                        i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/, true];
                    case 5: return [2 /*return*/, null];
                }
            });
        });
    };
    MetadataHandler.prototype.handleAsset = function (asset) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var assetCDNQuery, dType, dType, i, mediaItem, metadataLink, url, _b, playbackUrl, streaming_server_id, error_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        console.time('[zapp][VimmiPI][MetadataHandler][handleAsset]');
                        assetCDNQuery = {};
                        if (Config.get('authInfo.privateId') && Config.get('authInfo.device_id')) {
                            assetCDNQuery = {
                                tuid: Config.get('authInfo.privateId'),
                                tdid: Config.get('authInfo.device_id')
                            };
                        }
                        if (asset.assetCDNQuery) {
                            Object.assign(assetCDNQuery, asset.assetCDNQuery);
                        }
                        /** todo: need to refactor*/
                        if (Config.get('ams.portal.player.metadata')) {
                            Object.assign(assetCDNQuery, Config.get('ams.portal.player.metadata'));
                        }
                        if (asset.origin) {
                            assetCDNQuery.origin = asset.origin;
                        }
                        if (asset.active_drm) {
                            assetCDNQuery.drmType = asset.active_drm;
                        }
                        if (asset.metadataLang) {
                            if (this.isApplicableLang(asset, asset.metadataLang)) {
                                dType = getDTypeForAsset(asset);
                                if (dType) {
                                    assetCDNQuery.d = dType;
                                }
                                assetCDNQuery.l = asset.metadataLang;
                            }
                            else if (this.isApplicableMetadataLang(asset)) {
                                dType = getDTypeForAsset(asset);
                                if (dType) {
                                    assetCDNQuery.d = dType;
                                    assetCDNQuery.l = asset.metadataLang;
                                }
                                else if (asset.item.m_audio && asset.item.m_audio.length) {
                                    assetCDNQuery.l = asset.item.m_audio[0];
                                    asset.metadataLang = asset.item.m_audio[0];
                                }
                            }
                            else {
                                delete asset.metadataLang;
                            }
                        }
                        asset.assetCDNQuery = assetCDNQuery;
                        i = 0;
                        _c.label = 1;
                    case 1:
                        if (!(i !== asset.media.length)) return [3 /*break*/, 6];
                        mediaItem = asset.media[i];
                        if (!(mediaItem.link || (((_a = mediaItem === null || mediaItem === void 0 ? void 0 : mediaItem.preview_info) === null || _a === void 0 ? void 0 : _a.link) && asset.preview))) return [3 /*break*/, 5];
                        metadataLink = asset.preview ? mediaItem.preview_info.link : mediaItem.link;
                        if (metadataLink.indexOf('/metadata.xml') !== -1) {
                            metadataLink = rewriteMetadataXMLtoJSON(metadataLink);
                        }
                        url = formatMetadataUrl(new URL(metadataLink), assetCDNQuery);
                        if (asset.preview) {
                            mediaItem.preview_info.link = url.toString();
                        }
                        else {
                            mediaItem.link = url.toString();
                        }
                        if (this.analyticsModule) {
                            this.analyticsModule.send('meta_request', {}, {
                                asset: asset
                            });
                        }
                        _c.label = 2;
                    case 2:
                        _c.trys.push([2, 4, , 5]);
                        if (this.beforeMetadataReqCallback) {
                            this.beforeMetadataReqCallback(asset);
                        }
                        _b = mediaItem;
                        return [4 /*yield*/, this.getMetadataInfo(asset, mediaItem)];
                    case 3:
                        _b.CDNMetadata = _c.sent();
                        asset.playbackUrls = mediaItem.CDNMetadata.playbackUrls;
                        if (this.analyticsModule) {
                            playbackUrl = mediaItem.CDNMetadata.playbackUrls && mediaItem.CDNMetadata.playbackUrls.length ? mediaItem.CDNMetadata.playbackUrls[0].url : null;
                            streaming_server_id = mediaItem.CDNMetadata.playbackUrls && mediaItem.CDNMetadata.playbackUrls.length ? mediaItem.CDNMetadata.playbackUrls[0].serverId : null;
                            this.analyticsModule.send('meta_response', {
                                playback_url: playbackUrl,
                                streaming_server_id: streaming_server_id
                            }, {
                                asset: asset
                            });
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _c.sent();
                        if (!error_1.errSource) {
                            error_1 = new appError.AppError(errorCodes.ErrorCodes.NET_ERR, (error_1.code || 'Unknown error') + " " + (error_1.statusCode || ''), error_1.message);
                        }
                        if (this.analyticsModule) {
                            this.analyticsModule.send('meta_error', {}, {
                                error: error_1,
                                asset: asset
                            });
                        }
                        return [3 /*break*/, 5];
                    case 5:
                        i++;
                        return [3 /*break*/, 1];
                    case 6:
                        asset.isMetadataLoaded = true;
                        console.timeEnd('[zapp][VimmiPI][MetadataHandler][handleAsset]');
                        return [2 /*return*/, asset];
                }
            });
        });
    };
    MetadataHandler.prototype.getMetadataInfo = function (asset, mediaItem) {
        return __awaiter(this, void 0, void 0, function () {
            var metadataLink;
            var _this = this;
            return __generator(this, function (_a) {
                console.time('[zapp][VimmiPI][MetadataHandler][getMetadataInfo]');
                metadataLink = (asset.preview && mediaItem.preview_info && mediaItem.preview_info.link) ? mediaItem.preview_info.link : mediaItem.link;
                return [2 /*return*/, doFetch.doFetch(metadataLink, {
                        method: 'get'
                    })
                        .then(function (metadata) {
                        if (metadata.error) {
                            throw new appError.AppError(errorCodes.ErrorCodes.CDN_ERR, "The metadata for the asset not found", metadata.error);
                        }
                        if (!metadata.playbackUrls || !metadata.playbackUrls.length || metadata.cdnInfo.servers.length > metadata.playbackUrls.length) {
                            _this.fillPlaybackUrls(metadata.playbackLinks.smilUrls[0].url, metadata);
                        }
                        metadata.playbackUrls.map(function (playbackUrlItem) {
                            if (!playbackUrlItem.mimeType) {
                                playbackUrlItem.mimeType = getMimeType(playbackUrlItem, Config.get('mimeTypes'));
                            }
                            if (asset.active_drm && !playbackUrlItem.drm && mediaItem.drm) {
                                playbackUrlItem.drm = mediaItem.drm;
                                playbackUrlItem.drm.type = asset.active_drm;
                                playbackUrlItem.drm.mimeType = Config.get('drmKeySystems')[asset.active_drm] ? Config.get('drmKeySystems')[asset.active_drm][0] : 'unknown';
                            }
                        });
                        console.timeEnd('[zapp][VimmiPI][MetadataHandler][getMetadataInfo]');
                        return metadata;
                    })];
            });
        });
    };
    MetadataHandler.prototype.fillPlaybackUrls = function (baseUrl, metadata) {
        metadata.playbackUrls = [];
        var smillUrl = new URL(baseUrl);
        metadata.cdnInfo.servers.map(function (serverItem, index) {
            smillUrl.host = serverItem.address;
            metadata.playbackUrls.push({
                priority: serverItem.priority,
                serverId: serverItem.address,
                cdn: null,
                url: smillUrl.toString()
            });
        });
    };
    return MetadataHandler;
}());

var MediaIdHandler = /** @class */ (function () {
    function MediaIdHandler(vimmiPI) {
        this.vimmiPI = vimmiPI;
        this.analyticsModule = null;
        this.beforePlayReqCallback = null;
    }
    MediaIdHandler.prototype.beforePlayReq = function (fn) {
        this.beforePlayReqCallback = fn;
    };
    MediaIdHandler.prototype.attachAnalytics = function (analyticsModule) {
        if (analyticsModule) {
            this.analyticsModule = analyticsModule;
        }
        return this;
    };
    MediaIdHandler.prototype.handle = function (inputOptions, isNextItem, cache) {
        var _a, _b, _c, _d;
        if (isNextItem === void 0) { isNextItem = false; }
        if (cache === void 0) { cache = true; }
        return __awaiter(this, void 0, void 0, function () {
            var asset, drm_types, DRMSupStatus, finalDrmType, path, url, cacheIndex, data, responseTime, requestTime, cached, callDuration, respTime, error_1, i, mediaItem, playbackUrlItem;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        console.time('[zapp][VimmiPI][MediaIdHandler][handle]');
                        asset = inputOptions;
                        if (!asset.media_id) {
                            throw new appError.AppError(errorCodes.ErrorCodes.MISS_PARAMETER, 'Missed property', "\"media_id\" property is missed in the \"inputOptions\"!");
                        }
                        drm_types = asset.drm_types || [];
                        if (!drm_types.length) return [3 /*break*/, 3];
                        if (!!asset.active_drm) return [3 /*break*/, 2];
                        return [4 /*yield*/, DRMSupportsStatus()];
                    case 1:
                        DRMSupStatus = _e.sent();
                        console.log({ DRMSupStatus: DRMSupStatus });
                        finalDrmType = hasContentSupportsDRM(drm_types, Object.keys(DRMSupStatus.supportedSystems));
                        if (!finalDrmType) {
                            throw new appError.AppError(errorCodes.ErrorCodes.APP_ERR, 'Browser doesn\'t support the DRM types', "The Browser doesn't support the DRM types that the content supports!");
                        }
                        asset.active_drm = finalDrmType;
                        return [3 /*break*/, 3];
                    case 2:
                        if (drm_types.indexOf(asset.active_drm) === -1) {
                            throw new appError.AppError(errorCodes.ErrorCodes.APP_ERR, 'content doesn\'t support the DRM type', "The content doesn't support the DRM type \"" + asset.active_drm + "\"!");
                        }
                        _e.label = 3;
                    case 3:
                        asset.amsHeaders = generateHeaders.generateHeaders(asset.amsHeaders || {}, getAccessData(), true);
                        if (asset.active_drm) {
                            asset.amsHeaders['x-dhs-drm'] = asset.active_drm;
                        }
                        path = "/play/" + asset.media_id;
                        if (asset.mediaLink) {
                            path = asset.mediaLink;
                        }
                        if (isNextItem) {
                            path = path.replace('/play/', '/playnext/');
                        }
                        url = formatPath.formatPath(path, true, getAccessData());
                        cacheIndex = getUrlCacheIndex.getUrlCacheIndex(url);
                        requestTime = Date.now();
                        if (this.beforePlayReqCallback) {
                            this.beforePlayReqCallback(asset);
                        }
                        if (!(cache && localCache.localCache.get(cacheIndex))) return [3 /*break*/, 4];
                        cached = true;
                        data = localCache.localCache.get(cacheIndex);
                        responseTime = Date.now();
                        return [3 /*break*/, 9];
                    case 4:
                        callDuration = Date.now();
                        if (this.analyticsModule) {
                            this.analyticsModule.send('ams_request', {
                                ams_url: url.toString()
                            });
                        }
                        respTime = void 0;
                        _e.label = 5;
                    case 5:
                        _e.trys.push([5, 7, , 8]);
                        return [4 /*yield*/, fetchAMS.fetchAMS.get(url.toString(), {
                                headers: asset.amsHeaders
                            })];
                    case 6:
                        data = _e.sent();
                        respTime = Date.now();
                        return [3 /*break*/, 8];
                    case 7:
                        error_1 = _e.sent();
                        if (this.analyticsModule) {
                            this.analyticsModule.send('play_error', {
                                item_id: asset.media_id,
                                itype: asset.media || null,
                                content_title: asset.extraData.title || null
                            }, {
                                error: error_1,
                                asset: asset
                            });
                        }
                        throw error_1;
                    case 8:
                        if (cache && (data === null || data === void 0 ? void 0 : data.op)) {
                            localCache.localCache.set(cacheIndex, data, ((_a = data === null || data === void 0 ? void 0 : data.op) === null || _a === void 0 ? void 0 : _a.cache_time) || undefined);
                        }
                        /** send only if success response*/
                        if (respTime && this.analyticsModule) {
                            this.analyticsModule.send('ams_response', {
                                ams_url: url.toString()
                            }, { duration: respTime - callDuration });
                        }
                        _e.label = 9;
                    case 9:
                        asset.media = data.media || [];
                        asset = fillAssetFromResponse(asset, data.head);
                        asset.playbackUrls = [];
                        i = 0;
                        _e.label = 10;
                    case 10:
                        if (!(i != asset.media.length)) return [3 /*break*/, 19];
                        mediaItem = asset.media[i];
                        if (!((mediaItem.link && mediaItem.link.indexOf('/metadata.xml') !== -1) || (asset.preview && (((_b = mediaItem === null || mediaItem === void 0 ? void 0 : mediaItem.preview_info) === null || _b === void 0 ? void 0 : _b.link) || '').indexOf('/metadata.xml') !== -1))) return [3 /*break*/, 11];
                        asset.deliveryMethod = 'metadata';
                        return [3 /*break*/, 18];
                    case 11:
                        if (!((((_c = mediaItem === null || mediaItem === void 0 ? void 0 : mediaItem.preview_info) === null || _c === void 0 ? void 0 : _c.link) && asset.preview) || (mediaItem.link && !asset.preview) || (!((_d = mediaItem === null || mediaItem === void 0 ? void 0 : mediaItem.preview_info) === null || _d === void 0 ? void 0 : _d.link) && mediaItem.link && asset.preview))) return [3 /*break*/, 12];
                        asset.deliveryMethod = 'playback';
                        playbackUrlItem = {
                            priority: 1,
                            serverId: null,
                            cdn: null,
                            url: mediaItem.link ? mediaItem.link : asset.preview ? mediaItem.preview_info.link : null
                        };
                        if (asset.active_drm && mediaItem.drm) {
                            playbackUrlItem.drm = mediaItem.drm;
                            playbackUrlItem.drm.type = asset.active_drm;
                            playbackUrlItem.drm.mimeType = Config.get('drmKeySystems')[asset.active_drm] ? Config.get('drmKeySystems')[asset.active_drm][0] : 'unknown';
                        }
                        playbackUrlItem.mimeType = getMimeType(playbackUrlItem, Config.get('mimeTypes'));
                        asset.playbackUrls.push(playbackUrlItem);
                        return [3 /*break*/, 18];
                    case 12:
                        if (!(!asset.item.not_free && asset.alphaId)) return [3 /*break*/, 17];
                        _e.label = 13;
                    case 13:
                        _e.trys.push([13, 15, , 16]);
                        return [4 /*yield*/, this.vimmiPI.loadPlayTemplates(true)];
                    case 14:
                        _e.sent();
                        return [3 /*break*/, 16];
                    case 15:
                        _e.sent();
                        return [3 /*break*/, 16];
                    case 16:
                        mediaItem.link = getMetadataLinkFromTemplate(asset, asset.isLive);
                        if (!mediaItem.link) {
                            throw new appError.AppError(errorCodes.ErrorCodes.AMS_ERR, 'media links', "The media item doesn't have any playable link");
                        }
                        else {
                            asset.deliveryMethod = 'metadata';
                        }
                        return [3 /*break*/, 18];
                    case 17: throw new appError.AppError(errorCodes.ErrorCodes.AMS_ERR, 'media links', "The media item doesn't have any playable link");
                    case 18:
                        i++;
                        return [3 /*break*/, 10];
                    case 19:
                        if (this.analyticsModule) {
                            this.analyticsModule.send('play_request', {
                                ams_url: url.toString(),
                                item_id: asset.item.id,
                                itype: asset.item.itype,
                                content_title: asset.item.title
                            }, {
                                asset: asset,
                                buffer_timestamp: requestTime
                            });
                        }
                        if (this.analyticsModule) {
                            this.analyticsModule.send('play_response', {
                                ams_url: url.toString(),
                                item_id: asset.item.id,
                                itype: asset.item.itype,
                                content_title: asset.item.title,
                                cached: !!cached
                            }, {
                                asset: asset,
                                buffer_timestamp: responseTime
                            });
                        }
                        console.timeEnd('[zapp][VimmiPI][MediaIdHandler][handle]');
                        return [2 /*return*/, asset];
                }
            });
        });
    };
    MediaIdHandler.prototype.getNextByCurrentAsset = function (inputOptions) {
        return __awaiter(this, void 0, void 0, function () {
            var asset;
            return __generator(this, function (_a) {
                asset = Object.assign({}, inputOptions);
                return [2 /*return*/, this.handle(asset, true)];
            });
        });
    };
    return MediaIdHandler;
}());

var PlaybackRecovery = /** @class */ (function () {
    function PlaybackRecovery(metadataHandler, eventEmitter, asset) {
        this.metadataHandler = metadataHandler;
        this.eventEmitter = eventEmitter;
        this.asset = asset;
        this.metadataAttempts = 1;
        this.maxMetadataAttempts = 3;
        this.currentPlaybackIndex = 0;
        this.metadataHandler = metadataHandler;
        // use as default the first media item
        this.mediaItem = asset.media[0];
        // if (this.asset.deliveryMethod === 'metadata') {
        //     this.metadata = this.mediaItem.CDNMetadata;
        // }
    }
    PlaybackRecovery.prototype.getNextPlayback = function () {
        return __awaiter(this, void 0, void 0, function () {
            var err, err, newCDNMetadata, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        console.time('[zapp][VimmiPI][PlaybackRecovery][getNextPlayback]');
                        if (!this.asset.playbackUrls || !this.asset.playbackUrls.length) {
                            err = new appError.AppError(errorCodes.ErrorCodes.CDN_ERR, 'playbackUrls', "The playbackUrls is empty!");
                            this.eventEmitter.emit('playback_error', err);
                            throw err;
                        }
                        if (this.metadataAttempts > this.maxMetadataAttempts) {
                            err = new appError.AppError(errorCodes.ErrorCodes.CDN_ERR, 'playbackUrls', "No found playback urls anymore!");
                            this.eventEmitter.emit('playback_error', err);
                            throw err;
                        }
                        if (!(this.currentPlaybackIndex === this.asset.playbackUrls.length && this.metadataAttempts < this.maxMetadataAttempts)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.metadataHandler.getMetadataInfo(this.asset, this.mediaItem)];
                    case 1:
                        newCDNMetadata = _a.sent();
                        this.asset.playbackUrls = newCDNMetadata.playbackUrls;
                        this.mediaItem.CDNMetadata = newCDNMetadata;
                        // this.metadata = newCDNMetadata;
                        this.currentPlaybackIndex = 0;
                        this.metadataAttempts++;
                        _a.label = 2;
                    case 2:
                        if (this.currentPlaybackIndex + 1 === this.asset.playbackUrls.length && this.metadataAttempts == this.maxMetadataAttempts) {
                            //for increase metadata counter counter
                            this.metadataAttempts++;
                        }
                        console.timeEnd('[zapp][VimmiPI][PlaybackRecovery][getNextPlayback]');
                        this.activePlayback = this.getNext();
                        this.currentPlaybackIndex++;
                        return [2 /*return*/, this.activePlayback];
                    case 3:
                        e_1 = _a.sent();
                        console.log('unknown error', e_1);
                        return [2 /*return*/, this.activePlayback];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    PlaybackRecovery.prototype.getNext = function () {
        console.time('[zapp][VimmiPI][PlaybackRecovery][getNext]');
        var activePlayback = this.asset.playbackUrls[this.currentPlaybackIndex];
        this.asset.activePlayback = activePlayback;
        if (this.metadataAttempts === 1 && this.currentPlaybackIndex === 0) {
            console.timeEnd('[zapp][VimmiPI][PlaybackRecovery][getNext]');
            this.eventEmitter.emit('playback_created', activePlayback);
        }
        else {
            console.timeEnd('[zapp][VimmiPI][PlaybackRecovery][getNext]');
            this.eventEmitter.emit('playback_updated', activePlayback);
        }
        return activePlayback;
    };
    PlaybackRecovery.prototype.destroy = function () {
    };
    return PlaybackRecovery;
}());

var Concurrency = /** @class */ (function () {
    function Concurrency(eventEmitter) {
        this.eventEmitter = eventEmitter;
        this.currentAsset = null;
        this.concurrencyConf = null;
        this.keepAliveWatcherId = null;
        this.isWaitingPlayResponse = false;
        this.isWaitingStopResponse = false;
    }
    Concurrency.prototype.isContentRelevant = function (notFree) {
        if (notFree === void 0) { notFree = false; }
        if (notFree === undefined) {
            throw new appError.AppError(errorCodes.ErrorCodes.MISS_PARAMETER, 'Missed property', "\"notFree\" property is missed!");
        }
        var type = notFree ? 'not_free' : null;
        return (type && this.concurrencyConf && this.concurrencyConf.content && this.concurrencyConf.content.indexOf(type) !== -1);
    };
    Concurrency.prototype.initKeepAliveWatcher = function () {
        var _this = this;
        if (this.keepAliveWatcherId) {
            this.destroyKeepAliveWatcher();
        }
        var url = new URL(getCurrentProtocol.getCurrentProtocol() + "//" + normDomain.normDomain(this.concurrencyConf.ep) + "/op/keepalive/");
        url.searchParams.append('d', Config.get('deviceRestrictions'));
        this.keepAliveWatcherId = setInterval(function () {
            if (_this.concurrencyConf.cgrp) {
                url.searchParams.set('cgrp', decodeURIComponent(_this.concurrencyConf.cgrp));
            }
            url.searchParams.set("user", Config.get('authInfo.privateId'));
            url.searchParams.set("sid", Config.get('authInfo.sid'));
            url.searchParams.set("udid", Config.get('authInfo.device_id'));
            doFetch.doFetch(url.toString(), {
                method: 'get'
            }).then(function (data) {
                _this.currentAsset.concurrency = {
                    message: !data.res ? 'Concurrency system restriction' : null,
                    cmd: data.cmd,
                    res: data.res
                };
                _this.currentAsset.restricted = !data.res ? 'concurrency' : null;
                _this.eventEmitter.emit('concurrency_state', _this.currentAsset.concurrency);
            })["catch"](function (error) {
            });
        }, this.concurrencyConf.cgap * 1000);
        console.log("Concurrency watcher " + this.keepAliveWatcherId + " set up, interval: " + this.concurrencyConf.cgap + "s");
    };
    Concurrency.prototype.destroyKeepAliveWatcher = function () {
        clearInterval(this.keepAliveWatcherId);
        console.log("Concurrency watcher " + this.keepAliveWatcherId + " destroyed");
        this.keepAliveWatcherId = null;
    };
    Concurrency.prototype.setAsset = function (asset) {
        this.currentAsset = asset;
    };
    Concurrency.prototype.applyConf = function (newConf) {
        if (!this.concurrencyConf || (this.concurrencyConf.content !== newConf.content || this.concurrencyConf.cgap !== newConf.cgap || this.concurrencyConf.ep !== newConf.ep || this.concurrencyConf.cgrp !== newConf.cgrp)) {
            this.concurrencyConf = Object.assign({}, this.concurrencyConf, newConf);
        }
    };
    Concurrency.prototype.canPlay = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                // notFree = notFree !== undefined ? notFree : this.currentAsset.item.not_free;
                if (!this.currentAsset.item || !this.isContentRelevant(this.currentAsset.item.not_free)) {
                    return [2 /*return*/, {
                            cmd: 'play',
                            res: true
                        }];
                }
                url = new URL(getCurrentProtocol.getCurrentProtocol() + "//" + normDomain.normDomain(this.concurrencyConf.ep) + "/op/play/");
                url.searchParams.append('d', Config.get('deviceRestrictions'));
                if (this.concurrencyConf.cgrp) {
                    url.searchParams.set('cgrp', decodeURIComponent(this.concurrencyConf.cgrp));
                }
                url.searchParams.set("user", Config.get('authInfo.privateId'));
                url.searchParams.set("sid", Config.get('authInfo.sid'));
                url.searchParams.set("udid", Config.get('authInfo.device_id'));
                return [2 /*return*/, doFetch.doFetch(url.toString(), {
                        method: 'get'
                    }).then(function (data) {
                        return {
                            message: !data.res ? 'Concurrency system restriction' : null,
                            cmd: data.cmd,
                            res: data.res
                        };
                    })["catch"](function (error) {
                        return {
                            cmd: 'play',
                            res: true
                        };
                    })];
            });
        });
    };
    Concurrency.prototype.isSessionActive = function () {
        return !!this.keepAliveWatcherId;
    };
    Concurrency.prototype.play = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // notFree = notFree !== undefined ? notFree : this.currentAsset.item.not_free;
                        if (this.isWaitingPlayResponse) {
                            return [2 /*return*/];
                        }
                        if (!this.currentAsset.item || !this.isContentRelevant(this.currentAsset.item.not_free)) {
                            return [2 /*return*/, {
                                    cmd: 'play',
                                    res: true
                                }];
                        }
                        if (!!this.keepAliveWatcherId) return [3 /*break*/, 2];
                        this.isWaitingPlayResponse = true;
                        return [4 /*yield*/, this.canPlay()];
                    case 1:
                        result = _a.sent();
                        this.isWaitingPlayResponse = false;
                        this.currentAsset.concurrency = result;
                        this.currentAsset.restricted = !result.res ? 'concurrency' : null;
                        this.eventEmitter.emit('concurrency_state', this.currentAsset.concurrency);
                        if (result.res) {
                            this.initKeepAliveWatcher();
                        }
                        return [2 /*return*/, result];
                    case 2: 
                    /** todo: need to check possible errors*/
                    return [2 /*return*/, {
                            cmd: 'play',
                            res: true
                        }];
                }
            });
        });
    };
    Concurrency.prototype.stop = function (beacon) {
        if (beacon === void 0) { beacon = false; }
        return __awaiter(this, void 0, void 0, function () {
            var url;
            var _this = this;
            return __generator(this, function (_a) {
                if (!this.currentAsset || !this.currentAsset.item) {
                    return [2 /*return*/, true];
                }
                if (this.currentAsset && !this.isContentRelevant(this.currentAsset.item.not_free) && !this.keepAliveWatcherId) {
                    return [2 /*return*/, true];
                }
                if (!this.keepAliveWatcherId || this.isWaitingStopResponse) {
                    return [2 /*return*/, true];
                }
                this.destroyKeepAliveWatcher();
                url = new URL(getCurrentProtocol.getCurrentProtocol() + "//" + normDomain.normDomain(this.concurrencyConf.ep) + "/op/stop/");
                url.searchParams.append('d', Config.get('deviceRestrictions'));
                if (this.concurrencyConf.cgrp) {
                    url.searchParams.set('cgrp', decodeURIComponent(this.concurrencyConf.cgrp));
                }
                url.searchParams.set("user", Config.get('authInfo.privateId'));
                url.searchParams.set("sid", Config.get('authInfo.sid'));
                url.searchParams.set("udid", Config.get('authInfo.device_id'));
                if (beacon && window.fetch) {
                    return [2 /*return*/, fetch(url.toString(), {
                            method: 'GET',
                            keepalive: true
                        }).then(function (response) {
                            _this.isWaitingStopResponse = false;
                            return true;
                            // let data = response.data;
                            // return data.res;
                        })];
                }
                else if (beacon && navigator.sendBeacon) {
                    navigator.sendBeacon(url.toString(), '');
                    return [2 /*return*/, true];
                }
                else {
                    this.isWaitingStopResponse = true;
                    return [2 /*return*/, doFetch.doFetch(url.toString(), {
                            method: 'get'
                            // headers: this.getHeaders()
                        }).then(function (data) {
                            _this.isWaitingStopResponse = false;
                            return data.res;
                        })["catch"](function (error) {
                            _this.isWaitingStopResponse = false;
                            return true;
                        })];
                }
            });
        });
    };
    Concurrency.prototype.destroy = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.currentAsset) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.stop()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.currentAsset = null;
                        return [2 /*return*/];
                }
            });
        });
    };
    return Concurrency;
}());

Config.set({
    store: {
        prefix: 'acj_',
        encoding: false,
        cacheLifeTime: 7200000 // miliseconds / 2 hour
    },
    drmKeySystems: {
        'DASH/WIDEVINE': ['com.widevine.alpha'],
        'DASH/PLAYREADY': ['com.microsoft.playready', 'com.youtube.playready'],
        // clearkey: ['webkit-org.w3.clearkey', 'org.w3.clearkey'],
        // primetime: ['com.adobe.primetime', 'com.adobe.access'],
        'HLS/FAIRPLAY': ['com.apple.fps.1_0', 'com.apple.fairplay']
    },
    mimeTypes: {
        'mp4': 'video/mp4',
        'm4v': 'video/mp4',
        'm4a': 'audio/mp4',
        'webm': 'video/webm',
        'weba': 'audio/webm',
        'mkv': 'video/webm',
        'ts': 'video/mp2t',
        'ogv': 'video/ogg',
        'ogg': 'audio/ogg',
        'mpg': 'video/mpeg',
        'mpeg': 'video/mpeg',
        'm3u8': 'application/x-mpegurl',
        'mpd': 'application/dash+xml',
        'fm3u8': 'application/vnd.apple.mpegurl',
        'mp3': 'audio/mpeg',
        'aac': 'audio/aac',
        'flac': 'audio/flac',
        'wav': 'audio/wav'
    }
});
var VimmiPI = /** @class */ (function () {
    function VimmiPI() {
        this.analyticsModule = null;
        this.eventEmitter = new eventEmitter.EventEmitter();
        this.activeAsset = null;
        this.loadingAssets = [];
        this.activePlaybackLoader = null;
        this.concurrency = new Concurrency(this.eventEmitter);
        this.metadataHandler = new MetadataHandler(this);
        this.mediaIdHandler = new MediaIdHandler(this);
        console.log("VimmiPlayerIntegration(Version: " + "1.4.166" + ", Build date: " + "2021-07-30T20:01:53.080Z" + ")");
    }
    VimmiPI.prototype.debug = function (status) {
        if (status === void 0) { status = true; }
        return Config.set('debug', status);
    };
    /**
     * Attach analytics module
     * @param {object}   analyticsModule - analytics module instance
     * @param {function} analyticsModule.send - send method
     * @return {this}
     */
    VimmiPI.prototype.attachAnalytics = function (analyticsModule) {
        if (analyticsModule) {
            this.analyticsModule = analyticsModule;
            this.metadataHandler.attachAnalytics(analyticsModule);
            this.mediaIdHandler.attachAnalytics(analyticsModule);
            // this.playbackRecovery.attachAnalytics(vimmiAI);
        }
        return this;
    };
    /**
     * Subscribe on the plugin events
     * @param {string} eventName
     * @param {function} handler
     * @return {this}
     */
    VimmiPI.prototype.on = function (eventName, handler) {
        this.eventEmitter.on(eventName, handler);
        return this;
    };
    /**
     * Unsubscribe handler from event
     * @param {string} eventName
     * @param {function} handler
     * @return {this}
     */
    VimmiPI.prototype.off = function (eventName, handler) {
        this.eventEmitter.off(eventName, handler);
        return this;
    };
    /**
     * set conf
     * @param {object} data - the conf object(json)
     * @return {boolean}
     */
    VimmiPI.prototype.conf = function (data) {
        if (!data) {
            return null;
        }
        if (data.concurrency) {
            this.concurrency.applyConf(data.concurrency);
        }
        Config.set(data);
        return this;
    };
    /**
     * Get the asset by playback url, it means direct link to content
     * @async
     * @param {InputOptions} inputOptions
     * @param {boolean} isApplyAsset - Is apply the asset immediately after completing the asset preparation or just return
     * @return {boolean} Promise<Asset>
     */
    VimmiPI.prototype.getByPlaybackUrl = function (inputOptions, isApplyAsset) {
        if (isApplyAsset === void 0) { isApplyAsset = true; }
        return __awaiter(this, void 0, void 0, function () {
            var asset, playbackUrlItem;
            return __generator(this, function (_a) {
                asset = inputOptions;
                asset.playbackUrls = [];
                extendAsset(asset);
                // if (isApplyAsset && this.activeAsset) {
                //     await this.assetComplete();
                // }
                asset.deliveryMethod = 'playback';
                playbackUrlItem = {
                    priority: 1,
                    serverId: null,
                    cdn: null,
                    url: asset.playback_url
                };
                playbackUrlItem.mimeType = getMimeType(playbackUrlItem, Config.get('mimeTypes'));
                asset.playbackUrls.push(playbackUrlItem);
                if (isApplyAsset) {
                    this.applyAsset(asset);
                }
                return [2 /*return*/, asset];
            });
        });
    };
    /**
     * Get the asset by MediaStream object, for WebRTC streaming
     * @async
     * @param {InputOptions} inputOptions
     * @param {boolean} isApplyAsset - Is apply the asset immediately after completing the asset preparation or just return
     * @return {boolean} Promise<Asset>
     */
    VimmiPI.prototype.getByMediaStream = function (inputOptions, isApplyAsset) {
        if (isApplyAsset === void 0) { isApplyAsset = true; }
        return __awaiter(this, void 0, void 0, function () {
            var asset, playbackUrlItem;
            return __generator(this, function (_a) {
                asset = inputOptions;
                asset.playbackUrls = [];
                extendAsset(asset);
                asset.deliveryMethod = 'playback';
                playbackUrlItem = {
                    priority: 1,
                    serverId: null,
                    cdn: null,
                    srcObject: asset.mediaStream
                };
                asset.playbackUrls.push(playbackUrlItem);
                if (isApplyAsset) {
                    this.applyAsset(asset);
                }
                return [2 /*return*/, asset];
            });
        });
    };
    /**
     * Get the asset by metadata url, it means by the play Template
     * Not preferred to use!
     * @async
     * @param {InputOptions} inputOptions
     * @param {boolean} isApplyAsset - Is apply the asset immediately after completing the asset preparation or just return
     * @return {boolean} Promise<Asset>
     */
    VimmiPI.prototype.getByMetadataUrl = function (inputOptions, isApplyAsset) {
        if (isApplyAsset === void 0) { isApplyAsset = true; }
        return __awaiter(this, void 0, void 0, function () {
            var asset;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.metadataHandler.handle(inputOptions)];
                    case 1:
                        asset = _a.sent();
                        asset.deliveryMethod = 'metadata';
                        // asset.playbackUrls = [];
                        if (isApplyAsset) {
                            this.applyAsset(asset);
                        }
                        return [2 /*return*/, asset];
                }
            });
        });
    };
    /**
     * Get the asset by media id
     * @async
     * @param {Asset} rawAsset
     * @param {boolean} isApplyAsset - Is apply the asset immediately after completing the asset preparation or just return
     * @param {boolean} cache - do we need to cache the response
     * @return {boolean} Promise<Asset>
     */
    VimmiPI.prototype.getByMediaId = function (rawAsset, isApplyAsset, cache) {
        if (isApplyAsset === void 0) { isApplyAsset = true; }
        if (cache === void 0) { cache = true; }
        return __awaiter(this, void 0, void 0, function () {
            var asset, isApplied;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!Config.get('backend') || !isValidUrl.isValidUrl('https://' + Config.get('backend'))) {
                            throw new appError.AppError(errorCodes.ErrorCodes.MISS_PARAMETER, 'Missed property', "\"backend\" property is missed!");
                        }
                        extendAsset(rawAsset);
                        if (!(isApplyAsset && this.activeAsset)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.assetComplete()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.loadAMSConf(true)];
                    case 3:
                        _a.sent();
                        console.time('[zapp][VimmiPI][getByMediaId]');
                        return [4 /*yield*/, this.mediaIdHandler.handle(rawAsset, false, cache)];
                    case 4:
                        asset = _a.sent();
                        if (!isApplyAsset) return [3 /*break*/, 6];
                        this.loadingAssets.push(asset);
                        console.timeEnd('[zapp][VimmiPI][getByMediaId]');
                        return [4 /*yield*/, this.applyAsset(asset)];
                    case 5:
                        isApplied = _a.sent();
                        return [2 /*return*/, isApplied ? asset : null];
                    case 6:
                        console.timeEnd('[zapp][VimmiPI][getByMediaId]');
                        return [2 /*return*/, asset];
                }
            });
        });
    };
    VimmiPI.prototype.assetComplete = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.activeAsset) return [3 /*break*/, 2];
                        this.activeAsset = null;
                        if (this.playbackRecovery) {
                            this.playbackRecovery.destroy();
                            delete this.playbackRecovery;
                        }
                        return [4 /*yield*/, this.concurrency.destroy()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    VimmiPI.prototype.unloadAsset = function (asset) {
        var pos = this.loadingAssets.indexOf(asset);
        if (pos !== -1) {
            this.loadingAssets.splice(pos, 1);
        }
    };
    VimmiPI.prototype.getActiveAsset = function () {
        return this.activeAsset;
    };
    VimmiPI.prototype.isConcurSessionActive = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.concurrency.isSessionActive()];
            });
        });
    };
    VimmiPI.prototype.concurPlay = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.activeAsset) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.concurrency.play()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [2 /*return*/, null];
                }
            });
        });
    };
    VimmiPI.prototype.concurStop = function (beacon) {
        if (beacon === void 0) { beacon = false; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.concurrency.stop(beacon)
                        // return null;
                    ];
                    case 1: return [2 /*return*/, _a.sent()
                        // return null;
                    ];
                }
            });
        });
    };
    /**
     * Load new asset and initialize playing with the playback recovery
     * @async
     * @param {Asset} asset - asset for applying
     * @return {boolean} result
     */
    VimmiPI.prototype.applyAsset = function (asset) {
        if (asset === void 0) { asset = null; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!asset) {
                            throw new appError.AppError(errorCodes.ErrorCodes.MISS_PARAMETER, 'Missed property', "\"asset\" property is missed!");
                        }
                        if (!(asset.deliveryMethod === 'metadata' && !asset.isMetadataLoaded)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.metadataHandler.handleAsset(asset)];
                    case 1:
                        asset = _a.sent();
                        _a.label = 2;
                    case 2:
                        console.time('[zapp][VimmiPI][applyAsset][start]');
                        if (this.loadingAssets.indexOf(asset) === this.loadingAssets.length - 1) {
                            this.activeAsset = asset;
                            this.concurrency.setAsset(asset);
                            if (asset.deliveryMethod === 'metadata') {
                                this.initPlaybackRecovery();
                                console.time('[zapp][VimmiPI][applyAsset][setTimeout]');
                                setTimeout(function () {
                                    console.timeEnd('[zapp][VimmiPI][applyAsset][setTimeout]');
                                    console.timeEnd('[zapp][VimmiPI][applyAsset][start]');
                                    _this.unloadAsset(asset);
                                    // this.loadingAssets.splice(this.loadingAssets.indexOf(asset), 1);
                                    _this.playbackRecovery.getNextPlayback();
                                });
                            }
                            else {
                                asset.activePlayback = asset.playbackUrls[0];
                                setTimeout(function () {
                                    console.timeEnd('[zapp][VimmiPI][applyAsset][start]');
                                    _this.unloadAsset(asset);
                                    _this.eventEmitter.emit('playback_created', asset.activePlayback);
                                });
                            }
                            return [2 /*return*/, true];
                        }
                        else {
                            this.unloadAsset(asset);
                            return [2 /*return*/, false];
                            // this.loadingAssets.splice(this.loadingAssets.indexOf(asset), 1);
                        }
                }
            });
        });
    };
    /**
     * Change the metadata language
     * @async
     * @param {string} newAudioLang - new language, the one from item.m_audio list
     * @return {Asset} result
     */
    VimmiPI.prototype.applyNewMetadataLang = function (newAudioLang) {
        return __awaiter(this, void 0, void 0, function () {
            var isChanged;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.activeAsset) {
                            console.warn('there is no active asset!');
                            return [2 /*return*/, false];
                        }
                        return [4 /*yield*/, this.metadataHandler.changeLang(this.activeAsset, newAudioLang)];
                    case 1:
                        isChanged = _a.sent();
                        if (!isChanged) return [3 /*break*/, 3];
                        this.initPlaybackRecovery();
                        return [4 /*yield*/, this.playbackRecovery.getNextPlayback()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/, isChanged];
                }
            });
        });
    };
    VimmiPI.prototype.updateMSI = function () {
        if (this.activeAsset) {
            this.activeAsset.media_session_id = makeHash.makeHash(32);
        }
    };
    /**
     * check does the language playing through the metadata
     * @return {boolean} result
     */
    VimmiPI.prototype.isApplicableMetadataLang = function (asset) {
        return this.metadataHandler.isApplicableMetadataLang(asset);
    };
    /**
     * Get the next episode asset
     * @async
     * @param {string|Asset} asset - current episode id or Asset for current episode
     * @return {boolean} Promise<boolean>
     */
    VimmiPI.prototype.getNextByCurrentAsset = function (asset) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!Config.get('backend') || !isValidUrl.isValidUrl('https://' + Config.get('backend'))) {
                            throw new appError.AppError(errorCodes.ErrorCodes.MISS_PARAMETER, 'Missed property', "\"backend\" property is missed!");
                        }
                        if (!asset) {
                            throw new appError.AppError(errorCodes.ErrorCodes.MISS_PARAMETER, 'Missed property', "\"asset\" property is missed!");
                        }
                        //
                        // let inputOptions = {} as InputOptions;
                        // if (typeof idOrAsset === 'string') {
                        //     inputOptions.media_id = idOrAsset;
                        // } else {
                        //     inputOptions.media_id = idOrAsset.media_id;
                        //     if (idOrAsset.active_drm) {
                        //         inputOptions.active_drm = idOrAsset.active_drm;
                        //     }
                        //     if (idOrAsset.drm_types) {
                        //         inputOptions.drm_types = idOrAsset.drm_types;
                        //     }
                        // }
                        return [4 /*yield*/, this.loadAMSConf(true)];
                    case 1:
                        //
                        // let inputOptions = {} as InputOptions;
                        // if (typeof idOrAsset === 'string') {
                        //     inputOptions.media_id = idOrAsset;
                        // } else {
                        //     inputOptions.media_id = idOrAsset.media_id;
                        //     if (idOrAsset.active_drm) {
                        //         inputOptions.active_drm = idOrAsset.active_drm;
                        //     }
                        //     if (idOrAsset.drm_types) {
                        //         inputOptions.drm_types = idOrAsset.drm_types;
                        //     }
                        // }
                        _a.sent();
                        return [4 /*yield*/, this.mediaIdHandler.getNextByCurrentAsset(asset)];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    VimmiPI.prototype.beforeMetadataReq = function (fn) {
        this.metadataHandler.beforeMetadataReq(fn);
    };
    VimmiPI.prototype.beforePlayReq = function (fn) {
        this.mediaIdHandler.beforePlayReq(fn);
    };
    /**
     * Try to load next playback_url for recovery the playback
     * @async
     * @param {any} extError - The app error
     * @return {boolean} result
     */
    VimmiPI.prototype.handlePlaybackError = function (extError) {
        var _this = this;
        if (extError && extError.name === 'playbackUrls') {
            return null;
        }
        if (this.activeAsset && this.activeAsset.deliveryMethod === 'metadata') {
            if (this.lastPlaybackErrorTimeoutId) {
                clearTimeout(this.lastPlaybackErrorTimeoutId);
            }
            this.lastPlaybackErrorTimeoutId = setTimeout(function () {
                if (!_this.activePlaybackLoader) {
                    _this.activePlaybackLoader = _this.playbackRecovery.getNextPlayback();
                    _this.activePlaybackLoader.then(function (result) {
                        _this.activePlaybackLoader = null;
                    })["catch"](function (error) {
                        _this.activePlaybackLoader = null;
                    });
                }
                _this.lastPlaybackErrorTimeoutId = null;
            }, 6000);
            return this.lastPlaybackErrorTimeoutId;
        }
        return null;
    };
    /**
     * Initialize the playback recovery mechanism
     * @async
     * @private
     * @param {function} callback
     * @return {this}
     */
    VimmiPI.prototype.initPlaybackRecovery = function (callback) {
        if (callback === void 0) { callback = null; }
        console.time('[zapp][VimmiPI][initPlaybackRecovery]');
        if (this.playbackRecovery) {
            this.playbackRecovery.destroy();
        }
        this.playbackRecovery = new PlaybackRecovery(this.metadataHandler, this.eventEmitter, this.activeAsset);
        if (callback) {
            this.eventEmitter.on('playback_updated', callback);
        }
        console.timeEnd('[zapp][VimmiPI][initPlaybackRecovery]');
        return this;
    };
    VimmiPI.prototype.loadPlayTemplates = function (storeResult) {
        if (storeResult === void 0) { storeResult = false; }
        return __awaiter(this, void 0, void 0, function () {
            var url, cacheIndex, headers, callDuration, respTime;
            var _this = this;
            return __generator(this, function (_a) {
                url = formatPath.formatPath('/playtemplate/', true, getAccessData());
                if (Config.get('playTemplates')) {
                    return [2 /*return*/, true];
                }
                cacheIndex = getUrlCacheIndex.getUrlCacheIndex(url);
                if (storeResult) {
                    if (localCache.localCache.get(cacheIndex)) {
                        if (!Config.get('playTemplates')) {
                            Config.set('playTemplates', localCache.localCache.get(cacheIndex));
                        }
                        return [2 /*return*/, true];
                    }
                }
                headers = generateHeaders.generateHeaders({}, getAccessData());
                callDuration = Date.now();
                if (this.analyticsModule) {
                    this.analyticsModule.send('ams_request', {
                        ams_url: url.toString()
                    });
                }
                return [2 /*return*/, fetchAMS.fetchAMS.get(url.toString(), { headers: headers, useCache: false }).then(function (data) {
                        var _a;
                        respTime = Date.now();
                        if (storeResult && (data === null || data === void 0 ? void 0 : data.op)) {
                            localCache.localCache.set(cacheIndex, { op: data.op, data: data, info: data.info }, (_a = data.op) === null || _a === void 0 ? void 0 : _a.cache_time);
                        }
                        Config.set('playTemplates', { info: data.info });
                        return true;
                    })["catch"](function (error) {
                        respTime = respTime || Date.now();
                        throw error;
                    })["finally"](function () {
                        if (respTime && _this.analyticsModule) {
                            _this.analyticsModule.send('ams_response', {
                                ams_url: url.toString()
                            }, {
                                duration: respTime - callDuration
                            });
                        }
                    })];
            });
        });
    };
    VimmiPI.prototype.loadAMSConf = function (storeResult) {
        if (storeResult === void 0) { storeResult = false; }
        return __awaiter(this, void 0, void 0, function () {
            var url, cacheIndex, data, headers, callDuration, respTime;
            var _this = this;
            return __generator(this, function (_a) {
                console.time('[zapp][VimmiPI][loadAMSConf]');
                url = formatPath.formatPath('/conf/', true, getAccessData());
                if (Config.get('ams')) {
                    return [2 /*return*/, true];
                }
                cacheIndex = getUrlCacheIndex.getUrlCacheIndex(url);
                if (storeResult) {
                    if (localCache.localCache.get(cacheIndex)) {
                        if (!Config.get('ams')) {
                            data = localCache.localCache.get(cacheIndex);
                            Config.set('ams', data.conf);
                        }
                        return [2 /*return*/, true];
                    }
                }
                headers = generateHeaders.generateHeaders({}, getAccessData());
                callDuration = Date.now();
                if (this.analyticsModule) {
                    this.analyticsModule.send('ams_request', {
                        ams_url: url.toString()
                    });
                }
                return [2 /*return*/, fetchAMS.fetchAMS.get(url.toString(), { headers: headers, useCache: false }).then(function (data) {
                        var _a;
                        respTime = respTime || Date.now();
                        var conf = Object.assign({}, data.head, data.conf);
                        if (storeResult && (data === null || data === void 0 ? void 0 : data.op)) {
                            localCache.localCache.set(cacheIndex, { op: data.op, conf: conf }, (_a = data.op) === null || _a === void 0 ? void 0 : _a.cache_time);
                        }
                        Config.set('ams', conf);
                        console.timeEnd('[zapp][VimmiPI][loadAMSConf]');
                        return true;
                    })["catch"](function (error) {
                        respTime = respTime || Date.now();
                        throw error;
                    })["finally"](function () {
                        if (respTime && _this.analyticsModule) {
                            _this.analyticsModule.send('ams_response', {
                                ams_url: url.toString()
                            }, {
                                duration: respTime - callDuration
                            });
                        }
                    })];
            });
        });
    };
    return VimmiPI;
}());

module.exports = VimmiPI;
